import { useState } from "react";
import { MapPinIcon, PhoneIcon } from "@heroicons/react/24/solid";
import Map from "../components/Map";
import KvkkPolicy from "../components/policies/kvkk";
import IlluminationPolicy from "../components/policies/illumination";
import DestructionPolicy from "../components/policies/destruction";
import InformationPolicy from "../components/policies/information";

export default function Footer() {
    const [form, setForm] = useState({ name: "", subject: "", message: "" });
    const [showMap, setShowMap] = useState(false)
    const [modalContent, setModalContent] = useState("");
    const [showModal, setShowModal] = useState(false);

    const handleOpenModal = (contentType) => {
        setModalContent(contentType);
        setShowModal(true);
    };

    const handleCloseModal = () => {
        setShowModal(false);
        setModalContent("");
    };

    const handleShowMap = () => {
        setShowMap(true);
    }

    const handleCloseMap = () => {
        setShowMap(false);
    }

    const handleChange = (e) => {
        setForm({ ...form, [e.target.name]: e.target.value });
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        const { name, subject, message } = form;
        const subjectArea = `${name} - ${subject}`;
        const body = `${message}`;
        window.location.href = `mailto:info@arkenom.com.tr?subject=${subjectArea}&body=${body}`;
    };

    return (
        <footer className="text-black py-4 px-6">

            <div className="max-w-4xl mx-auto grid gap-8">
                <div>
                    <form onSubmit={handleSubmit} className="space-y-4">
                        <input
                            type="text"
                            name="name"
                            placeholder="Name"
                            value={form.name}
                            onChange={handleChange}
                            className="w-full text-xs sm:text-base p-2 bg-gray-200 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
                            required
                            lang="en"
                        />
                        <input
                            type="text"
                            name="subject"
                            placeholder="Subject"
                            value={form.subject}
                            onChange={handleChange}
                            className="w-full text-xs sm:text-base p-2 bg-gray-200 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
                            required
                            lang="en"
                        />
                        <textarea
                            name="message"
                            placeholder="Your Message"
                            value={form.message}
                            onChange={handleChange}
                            rows={4}
                            className="w-full text-xs sm:text-base p-2 bg-gray-200 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
                            required
                        ></textarea>
                        <button
                            type="submit"
                            className="w-full text-xs sm:text-base bg-blue-600 hover:bg-blue-700 text-white font-semibold py-2 rounded-md"
                        >
                            Send
                        </button>
                    </form>
                </div>
        
                <div className="flex items-center justify-between gap-2">
                    <p className="flex items-center text-xs sm:text-base gap-2 mb-2 text-gray-800">
                        <MapPinIcon className="w-5 h-5 cursor-pointer" onClick={handleShowMap} />
                        Beyoğlu/İstanbul
                    </p>
                    <p className="flex items-center text-xs sm:text-base gap-2 text-gray-800">
                        <PhoneIcon className="w-5 h-5" /> (0212) 807 08 00
                    </p>
                </div>
            </div>

            {showMap && (
                <div className="fixed inset-0 bg-gray-100 flex justify-center items-center" style={{ zIndex: 99999 }} onClick={handleCloseMap}>
                    <div className="bg-transparent p-6 rounded-lg shadow-lg w-3/6">
                        <div className="flex justify-end mb-5">
                            <svg xmlns="http://www.w3.org/2000/svg" onClick={handleCloseMap} fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="size-6 cursor-pointer">
                                <path strokeLinecap="round" strokeLinejoin="round" d="m9.75 9.75 4.5 4.5m0-4.5-4.5 4.5M21 12a9 9 0 1 1-18 0 9 9 0 0 1 18 0Z" />
                            </svg>
                        </div>
                        <Map />
                    </div>
                </div>
            )}

            {showModal && (
                <div
                    className="fixed inset-0 bg-black bg-opacity-50 flex justify-center items-center z-[99999]"
                    onClick={handleCloseModal}
                >
                    <div
                        className="bg-white rounded-lg shadow-lg w-full max-w-2xl p-6 relative"
                        onClick={(e) => e.stopPropagation()}
                    >
                        <button
                            onClick={handleCloseModal}
                            className="absolute top-4 right-4 text-gray-600 hover:text-black"
                        >
                            <svg
                                xmlns="http://www.w3.org/2000/svg"
                                fill="none"
                                viewBox="0 0 24 24"
                                strokeWidth={1.5}
                                stroke="currentColor"
                                className="w-6 h-6"
                            >
                                <path
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                    d="M6 18L18 6M6 6l12 12"
                                />
                            </svg>
                        </button>

                        <div className="text-sm text-gray-800 space-y-2 max-h-[70vh] overflow-y-auto">
                            {modalContent === "kvkk" && <KvkkPolicy />}
                            {modalContent === "illumination" && <IlluminationPolicy />}
                            {modalContent === "destruction" && <DestructionPolicy />}
                            {modalContent === "information" && <InformationPolicy />}
                        </div>
                    </div>
                </div>
            )}

            <div className="relative flex flex-col md:flex-row justify-between items-center mt-8 text-sm text-gray-600 px-5 sm:px-20">
                <p className="text-xs sm:text-base">© 2025 Developed by Arkenom Technology. All rights reserved.</p>
                <div className="flex space-x-4 mt-4 md:mt-0">
                    <button onClick={() => handleOpenModal("kvkk")} className="hover:underline text-xs sm:text-base">KVKK Policy</button>
                    <button onClick={() => handleOpenModal("illumination")} className="hover:underline text-xs sm:text-base">Illumination Policy</button>
                    <button onClick={() => handleOpenModal("destruction")} className="hover:underline text-xs sm:text-base">Destruction Policy</button>
                    <button onClick={() => handleOpenModal("information")} className="hover:underline text-xs sm:text-base">Information Security Policy</button>
                </div>
            </div>
        </footer>
    );
}